module.exports = __webpack_public_path__ + "img/2025-07-21b_5.9a104667.jpg";